/**
 * Fade-Bottom / Green-Blue-Violet.
 */ var GreenBlueViolet = [
    /**
     * Green Props.
     */ {
        variant: 'green',
        size: '912',
        rotate: 50,
        opacity: 0.3,
        blur: 21.1,
        x: '-389',
        y: '-524'
    },
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '912',
        rotate: -50,
        opacity: 0.3,
        blur: 21.3,
        x: '335',
        y: '-577'
    },
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '971',
        rotate: 125,
        opacity: 0.3,
        blur: 19.3,
        x: '1064',
        y: '-522'
    }
];

export { GreenBlueViolet as default };
//# sourceMappingURL=green-blue-violet.es.js.map
